import { render, staticRenderFns } from "./LeadDetail.vue?vue&type=template&id=2189fd30&scoped=true"
import script from "./LeadDetail.vue?vue&type=script&lang=ts"
export * from "./LeadDetail.vue?vue&type=script&lang=ts"
import style0 from "./LeadDetail.vue?vue&type=style&index=0&id=2189fd30&prod&lang=scss"
import style1 from "./LeadDetail.vue?vue&type=style&index=1&id=2189fd30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2189fd30",
  null
  
)

export default component.exports